import { Type, type Static } from '@sinclair/typebox';
import { PaginationQueryParamsSchema } from '../../shared/utils/pagination-query-params.schema';

export const GetCalendarsListQuerySchema = PaginationQueryParamsSchema;

export const GetCalendarParamsSchema = Type.Object({
  calendar_id: Type.String({ minLength: 1, description: 'Identifier of the calendar to retrieve ' }),
});

export const CreateCalendarBodySchema = Type.Object(
  {
    name: Type.String({ description: 'Name of the new calendar' }),
    description: Type.Optional(Type.String({ description: 'Description of the calendar' })),
    background_color: Type.Optional(Type.String({ description: 'Background color of the calendar in hexadecimal format.' })),
    timezone: Type.Optional(Type.String({ description: 'Timezone used in this calendar (IANA, e.g. `Europe/Paris`).' })),
  },
  { additionalProperties: false },
);

export const UpdateCalendarParamsSchema = Type.Object({
  calendar_id: Type.String({ minLength: 1, description: 'ID of the Calendar to update.' }),
});

export const UpdateCalendarBodySchema = Type.Object(
  {
    name: Type.Optional(Type.String({ description: 'Name of the new calendar' })),
    description: Type.Optional(Type.String({ description: 'Description of the calendar' })),
    background_color: Type.Optional(Type.String({ description: 'Background color of the calendar in hexadecimal format.' })),
    timezone: Type.Optional(Type.String({ description: 'Timezone used in this calendar (IANA, e.g. `Europe/Paris`).' })),
  },
  { additionalProperties: false },
);

export const DeleteCalendarParamsSchema = Type.Object({
  calendar_id: Type.String({ minLength: 1, description: 'ID of the calendar to delete.' }),
});

export type GetCalendarsListQuery = Static<typeof GetCalendarsListQuerySchema>;
export type GetCalendarParams = Static<typeof GetCalendarParamsSchema>;
export type CreateCalendarBody = Static<typeof CreateCalendarBodySchema>;
export type UpdateCalendarParams = Static<typeof UpdateCalendarParamsSchema>;
export type UpdateCalendarBody = Static<typeof UpdateCalendarBodySchema>;
export type DeleteCalendarParams = Static<typeof DeleteCalendarParamsSchema>;
